<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    const isInDingTalk = this.isInDingTalk();
    localStorage.setItem("isInDingTalk", isInDingTalk);
    if (isInDingTalk && process.env.NODE_ENV === "development") {
      import("eruda").then((eruda) => eruda.default.init());
    }

    // Initialize feature flags globally - using created instead of mounted to ensure
    // feature flags are available before child components' created hooks
    this.initializeFeatureFlags();
  },
  methods: {
    isInDingTalk() {
      const ua = navigator.userAgent.toLowerCase();
      return ua.indexOf("dingtalk") > -1 || ua.indexOf("dingtalk") > -1;
    },
    async initializeFeatureFlags() {
      try {
        await this.$store.dispatch('featureFlags/initFeatureFlags');
        console.log('Feature flags initialized globally');
      } catch (error) {
        console.error('Failed to initialize feature flags:', error);
      }
    },
  },
};
</script>

<style>
/* 全局样式可在此定义 */
:root {
  --background: #f5f7fa;
}
body {
  margin: 0;
  padding: 0;
  height: 100vh;
  background: var(--background);
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}

/* 移动端弹窗底部按钮修复：防止被钉钉/手机底部导航栏遮挡 */
@media (max-width: 768px) {
  /* el-dialog 全屏弹窗 */
  .el-dialog.is-fullscreen .el-dialog__footer {
    position: sticky;
    bottom: 0;
    background: #fff;
    padding-bottom: calc(20px + env(safe-area-inset-bottom, 0px));
    z-index: 10;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
  }
  .el-dialog.is-fullscreen .el-dialog__body {
    padding-bottom: 80px;
  }

  /* MessageBox.confirm 弹窗（内容过长时按钮被挤出屏幕） */
  .el-message-box {
    width: 95vw !important;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
  }
  .el-message-box .el-message-box__content {
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .el-message-box .el-message-box__btns {
    position: sticky;
    bottom: 0;
    background: #fff;
    padding: 10px 15px calc(10px + env(safe-area-inset-bottom, 0px));
    z-index: 10;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
  }
  .el-message-box .el-message-box__message {
    max-height: none;
    overflow: visible;
  }
}

/* 评分确认弹窗：按视口限制高度，内容滚动，按钮保持可见 */
.rating-confirm-dialog {
  width: min(90vw, 680px) !important;
  max-height: calc(100vh - 48px);
  display: inline-flex;
  flex-direction: column;
  vertical-align: middle;
  text-align: left;
}

.rating-confirm-dialog .el-message-box__content {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.rating-confirm-dialog .el-message-box__btns {
  flex-shrink: 0;
  background: #fff;
}

.rating-confirm-dialog .el-message-box__message {
  overflow: visible;
}

.rating-confirm-dialog table {
  table-layout: fixed;
  word-break: break-word;
}

@media (max-height: 700px) {
  .rating-confirm-dialog {
    max-height: calc(100vh - 24px);
  }

  .rating-confirm-dialog .el-message-box__header {
    padding: 12px 16px 8px;
  }

  .rating-confirm-dialog .el-message-box__content {
    padding: 8px 16px;
  }

  .rating-confirm-dialog .el-message-box__btns {
    padding: 8px 16px 12px;
  }

  .rating-confirm-dialog table th,
  .rating-confirm-dialog table td {
    padding: 6px !important;
  }
}
</style>
